import { CfAbstract } from "types/cf-utils/types";
import { CfPageExtra } from "types/pages/types";
import { CfTranslations } from "types/types";
import { logDebug } from "helpers/generic";
import { mergeUniqueBy } from "utilities/utils";

interface ActiveOnChannelItem extends Partial<CfPageExtra> {
  id: string;
  title?: string;
  link?: string;
  abstract?: CfAbstract;
  activeOnChannel?: string;
  currentItemPageUrl?: string;
}

export function activeOnChannel(obj: ActiveOnChannelItem) {
  logDebug(
    "process.env.GATSBY_PROJECT_SLUG",
    obj?.activeOnChannel?.includes(process.env.GATSBY_PROJECT_SLUG),
  );
  return obj?.activeOnChannel?.includes(process.env.GATSBY_PROJECT_SLUG);
}

export function filterActiveOnChannel(array: ActiveOnChannelItem[]) {
  if (!Array.isArray(array)) {
    return [];
  }
  const arrayFiltered = array.filter((item) => {
    if (!activeOnChannel(item) || item.activeOnChannel === null) {
      return false;
    }
    return item;
  });
  return arrayFiltered;
}

export function getTranslations(arrayTranslatons: CfTranslations[]) {
  const object: { [key: string]: string } = {};
  arrayTranslatons?.forEach((groupTranslations) => {
    groupTranslations.translations?.forEach((item) => {
      object[item.slug] = item.text.text;
    });
  });
  return object;
}

export function getFaqDetailPreview(list: ActiveOnChannelItem) {
  if (!Array.isArray(list)) {
    return [];
  }
  const listPreview: ActiveOnChannelItem[] = list.map((item) => {
    const newItem = {
      id: item.id,
      text: item.title,
      link: item.currentItemPageUrl,
      activeOnChannel: item.activeOnChannel,
    };
    return newItem;
  });
  return filterActiveOnChannel(listPreview);
}

export function getFaqDetailAccordionPreview(list: ActiveOnChannelItem[]) {
  if (!Array.isArray(list)) {
    return [];
  }
  const listPreview: ActiveOnChannelItem[] = list.map((item) => {
    const newItem = {
      id: item.id,
      title: item.title,
      link: item.currentItemPageUrl,
      abstract: item?.abstract?.abstract ?? "",
      activeOnChannel: item.activeOnChannel,
    };
    return newItem;
  });
  return filterActiveOnChannel(listPreview);
}

export function getFaqTopicPreview(list: ActiveOnChannelItem[]) {
  if (!Array.isArray(list)) {
    return [];
  }
  const listPreview = list.map((item) => {
    const newItem: ActiveOnChannelItem = {
      id: item.id,
      title: item.title,
      abstract: item?.abstract?.abstract ?? "",
      link: item.currentItemPageUrl,
      activeOnChannel: item.activeOnChannel,
    };
    return newItem;
  });
  return filterActiveOnChannel(listPreview);
}

export function getOthersRelatedByKey(
  list: CfPageExtra,
  key: string,
  removeCfId = undefined,
) {
  if (!Array.isArray(list)) {
    return [];
  }
  let arrayOthers: ActiveOnChannelItem[] = [];
  list.forEach((topics) => {
    const others = topics?.key ?? [];
    arrayOthers = mergeUniqueBy(arrayOthers, others, "contentful_id");
  });
  if (removeCfId) {
    arrayOthers = arrayOthers.filter(
      (item) => item.contentful_id !== removeCfId,
    );
  }
  return filterActiveOnChannel(arrayOthers);
}
